import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginService } from 'lps-navigation';
import { EnvironmentService } from '../core/enviroment/environment.service';
import { IDateRange } from './interfaces/date-range.interface';

@Injectable({
  providedIn: 'root'
})
export class ActionHistoryQueueService {

  public api_uri = this.environmentService.getEnvVar('base_url_roulette');

  constructor(private http: HttpClient, private loginService: LoginService, private environmentService: EnvironmentService) { }

  listActionHistoryQueue(page: number, maxResults: number, action = '', dateRange: IDateRange) {
    const { initialDate, endDate } = dateRange;
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.loginService.getAuthInformation().token);
    return this.http.get(`${this.api_uri}/queue/action-history?max_results=${maxResults}&page=${page}&action=${action}&dtIni=${initialDate}&dtEnd=${endDate}`, {headers});
  }

  reportActionHistory(initialDate: string, endDate: string) {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.loginService.getAuthInformation().token);
    return this.http.get(`${this.api_uri}/queue/action-history/report?dtIni=${initialDate}&dtEnd=${endDate}`, {headers});
  }

  listActionType() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.loginService.getAuthInformation().token);
    return this.http.get(`${this.api_uri}/queue/action-history/action-type`, {headers});
  }
}
